import { render, staticRenderFns } from "./SuggestRole.vue?vue&type=template&id=95b30296&"
import script from "./SuggestRole.vue?vue&type=script&lang=js&"
export * from "./SuggestRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports